import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type {
  IBankCreate,
  IInitialTransfer,
  ITransferBank,
  IBankUpdate,
} from "@/types/requests";
import type { IBank, IBankResponse } from "@/types/response";

class BankService extends BaseHttp {
  async getBanks(pageNumber: number, pageSize: number, searchTerm: string) {
    const { data } = await this.get<IBankResponse>(
      "",
      { pageNumber, pageSize, searchTerm },
      { requestKey: "getBanks" }
    );
    return data;
  }
  async getBankById(id: string) {
    const { data } = await this.get<{ bank: IBank }>(
      `/${id}`,
      {},
      { requestKey: "getBankById" }
    );
    return data;
  }
  async createBank(body: IBankCreate) {
    const { success, error } = await this.post<string>("", body, {
      requestKey: "createBank",
    });
    return { success, error };
  }
  async deleteBank(id: string) {
    const { success, error } = await this.delete<string>(
      `/${id}`,
      {},
      { requestKey: "deleteBank" }
    );
    return { success, error };
  }
  async transfer(id: string, transferId: string, body: ITransferBank) {
    const { success, error } = await this.post<string>(
      `/${id}/transfer/${transferId}`,
      body,
      { requestKey: "transfer" }
    );
    return { success, error };
  }
  async initialTransfer(id: string, body: IInitialTransfer) {
    const { success, error } = await this.post<string>(
      `/${id}/initial-transfer`,
      body,
      { requestKey: "initialTransfer" }
    );
    return { success, error };
  }

  async updateBank(id: string, body: IBankUpdate) {
    const { success, error } = await this.post<string>(`/${id}`, body, {
      requestKey: "updateBank",
    });
    return { success, error };
  }
}

export default new BankService(apiGwClient, "/api/v1/banks");
